export enum MenuItemType {
    SUPADEMO = 'supademo',
}

export const MenuItemsOpenableInModal = Object.values(MenuItemType);
